import React, { useEffect, useState } from 'react';
import { Drawer, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Container, Header, Body, Row } from './OpenActivity.styled';
import InputSearch from '../OpenActivity/OpenActivityTable/InputSearch';
import { Wrapper } from '../ClickActivity/ClickActivity.styled';
import ABToggleButton from '../ClickActivity/ABToggleButton';
import ExportBtn from '../OpenActivity/ExportBtn';
import OpenActivityTable from './OpenActivityTable/OpenActivityTable';
import { getLatestOpenDate } from './utils';
import { fetchOpenEventsData } from './api';

const OpenActivity = ({
  isOpenActivityDrawerVisible,
  setOpenActivityVisibility,
  initialMessage,
  orgId,
}) => {
  const [message, setMessage] = useState({});
  const [rows, setRows] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    if (initialMessage) {
      setMessage(initialMessage);
    }
  }, [initialMessage]);

  const getVersionName = message => {
    if (!message?.AB || !message.AB.version) return '';

    return `(Version ${message.AB.version})`;
  };

  const closeDrawer = () => {
    setOpenActivityVisibility(false);
  };

  const getOpenActivityTableRows = async ({ messageId, orgId, search }) => {
    const data = await fetchOpenEventsData({ messageId, orgId, ...search });
    const tableRows = [];
    for (const email in data.openEvents) {
      const contactLatestOpenDate = getLatestOpenDate(data.openEvents[email]);
      tableRows.push({
        _id: email,
        email,
        totalOpens: data.openEvents[email].length,
        latestOpenDate: contactLatestOpenDate,
        openEvents: data.openEvents[email],
      });
    }

    return tableRows;
  };

  return (
    <Drawer
      open={isOpenActivityDrawerVisible}
      onClose={closeDrawer}
      anchor="right"
    >
      <Container>
        <Header>
          <IconButton size={'small'} style={{ color: 'white' }}>
            <Close size={'small'} onClick={closeDrawer} />
          </IconButton>
          Open Activity: {message?.draftName} {getVersionName(message)}
        </Header>
        <Body>
          <Row>
            <InputSearch
              messageId={message.id}
              setLoading={setLoading}
              setRows={setRows}
              orgId={orgId}
              getTableRowData={getOpenActivityTableRows}
            />
            <Wrapper>
              {message?.AB && message?.AB.version && (
                <ABToggleButton message={message} setMessage={setMessage} />
              )}
              <ExportBtn tableRowData={rows} message={message} />
            </Wrapper>
          </Row>
          <OpenActivityTable
            isLoading={isLoading}
            setLoading={setLoading}
            messageId={message.id}
            rows={rows}
            setRows={setRows}
            orgId={orgId}
          />
        </Body>
      </Container>
    </Drawer>
  );
};

export default OpenActivity;
